module.exports = __webpack_public_path__ + "img/appAsset-ui--customize.0fa8d3b5.svg";